import { Injectable } from '@angular/core';
import { ShareRecommendationData } from '@app/core/models/share-recommendation-data';
import { Store } from '@ngrx/store';
import { AppState } from '../index';
import { resetShareRecommendation, setShareRecommendation } from './share-recommendation.actions';
import { selectShareRecommendationData } from './share-recommendation.selector';

@Injectable()
export class ShareRecommendationFacade {
  public selectShareRecommendationData$ = this.store.select(selectShareRecommendationData);

  constructor(private store: Store<AppState>) {}

  public setShareRecommendation(data: ShareRecommendationData): void {
    this.store.dispatch(setShareRecommendation({ data }));
  }

  public resetShareRecommendation(): void {
    this.store.dispatch(resetShareRecommendation());
  }
}
